/**
 * The browser never reached the server. The raw message is
 * "Failed to fetch" (or Safari's "Load failed"). That string is not
 * something to put on the page.
 */
export function unreachableSend(err) {
  const message = String(err?.message || '').trim().toLowerCase();
  return message === 'failed to fetch'
    || message === 'load failed'
    || message.includes('networkerror')
    || message.includes('network request failed');
}
